import { render, staticRenderFns } from "./DIS_twoTout.vue?vue&type=template&id=1d988e4f&"
import script from "./DIS_twoTout.vue?vue&type=script&lang=js&"
export * from "./DIS_twoTout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports